import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Button, Card, CardBody, CardHeader, Col, Form, FormFeedback, FormGroup, Input, Label, Row } from "reactstrap";
import Select from "react-select";
import { modelEmpEductaion, modelEmpFamily } from "./model_employee";
import axios from "axios";
import ConfigData from '../../config.json';
import { handlerRespError } from "../utility/handler_resp";
import { useHistory } from "react-router-dom";

const EmployeePersonal = ({dataProfile, dataEducation, dataFamily, idEmpGeneral, onSave, onCancel}) => {
    const [profile, setProfile] = useState(dataProfile);
    const [educations, setEducations] = useState(dataEducation);
    const [familys, setFamilys] = useState(dataFamily);
    const [selectProfileMaritalStatus, setSelectProfileMaritalStatus] = useState(null);
    const [ddlMaritalStatus, setDdlMaritalStatus] = useState([]);
    const [selectProfileMilitaryStatus, setSelectProfileMilitaryStatus] = useState(null);
    const [ddlMilitaryStatus, setDdlMilitaryStatus] = useState([]);
    const [selectEducationLevels, setSelectEducationLevels] = useState([null]);
    const [ddlEducationLevel, setDdlEducationLevel] = useState([]);
    const [selectEducationInstitutions, setSelectEducationInstitutions] = useState([null]);
    const [ddlEducationInstitution, setDdlEducationInstitution] = useState([]);
    const history = useHistory();
    let indexEducation = 0;
    let indexFamily = 0;

    useEffect(() => {
        LoadDataMaritalStatus();
        LoadDataMilitaryStatus();
        LoadDataLevelEducation();
        LoadDataInstitution();
    }, []);

    useEffect(() => {
        setProfile(dataProfile);
        setEducations(dataEducation);
        setFamilys(dataFamily);
        setSelectProfileMaritalStatus(ddlMaritalStatus.find(x => x.value === dataProfile.marital_status.toString()));
        setSelectProfileMilitaryStatus(ddlMilitaryStatus.find(x => x.value === dataProfile.military_status.toString()));

        let arrSelectEducationLevel = [];
        dataEducation.forEach(e => {
            let selectEL = ddlEducationLevel.filter(d => d.value === e.id_level_education.toString());
            arrSelectEducationLevel.push(selectEL);
        });
        setSelectEducationLevels(arrSelectEducationLevel);
        let arrSelectEducationInstitution = [];
        dataEducation.forEach(e => {
            let selectEI = ddlEducationInstitution.filter(d => d.value === e.id_institution.toString());
            arrSelectEducationInstitution.push(selectEI);
        });
        setSelectEducationInstitutions(arrSelectEducationInstitution);
    }, [dataProfile, dataEducation, dataFamily]);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            profile: profile,
            education: educations,
            family: familys,
        },
        validationSchema: Yup.object({
            profile: Yup.object().shape({
                address: Yup.string().required("Please enter a Address"),
                bank_account: Yup.string().required("Please enter a Bank account"),
                tax_id: Yup.string().required("Please enter a Tax ID"),
                sso_id: Yup.string().required("Please enter a SSO ID"),
                contact_name: Yup.string().required("Please enter a Name"),
                contact_phone_number: Yup.string().required("Please enter a Phone"),
                contact_relation: Yup.string().required("Please enter a Relationship"),
            }),
            education: Yup.array().of(
                Yup.object().shape({
                    id_level_education: Yup.string().required("Please select a Education level"),
                    id_institution: Yup.string().required("Please select a Institution"),
                    graduate_year: Yup.string().required("Please enter a Year of completion"),
                    gpa: Yup.string().required("Please enter a GPA"),
                })
            ),
            family: Yup.array().of(
                Yup.object().shape({
                    name: Yup.string().required("Please select a First name"),
                    surname: Yup.string().required("Please select a Last name"),
                    phone_number: Yup.string().required("Please enter a Phone"),
                    relationship: Yup.string().required("Please enter a Relationship"),
                })
            ),
        }),
        onSubmit: onSave
    });

    const onClickAddEducation = () => {
        const arrEducation = [...validation.values.education];
        arrEducation.push(modelEmpEductaion);
        setUpdateDataOnEvent(null, arrEducation, null);
        const arrSelectEducationLevel = [...selectEducationLevels];
        arrSelectEducationLevel.push("");
        setSelectEducationLevels(arrSelectEducationLevel);
        const arrSelectEducationInstitution = [...selectEducationInstitutions];
        arrSelectEducationInstitution.push("");
        setSelectEducationInstitutions(arrSelectEducationInstitution);
    };

    const onClickDeleteEducation = (index) => {
        const arrEducation = [...validation.values.education];
        let objEducation = {...arrEducation[index]};
        objEducation.status = "0";
        objEducation.id_institution = "-";
        objEducation.id_level_education = "-";
        objEducation.graduate_year = "-";
        objEducation.gpa = "-";
        arrEducation[index] = objEducation;
        validation.handleChange("education." + index + ".status")("0");
        validation.handleChange("education." + index + ".id_institution")("-");
        validation.handleChange("education." + index + ".id_level_education")("-");
        validation.handleChange("education." + index + ".graduate_year")("-");
        validation.handleChange("education." + index + ".gpa")("-");
        setUpdateDataOnEvent(null, arrEducation, null);
    };


    const onClickAddFamily = () => {
        const arrFamily = [...validation.values.family];
        arrFamily.push(modelEmpFamily);
        setUpdateDataOnEvent(null, null, arrFamily);
    };

    const onClickDeleteFamily= (index) => {
        const arrFamily = [...validation.values.family];
        let objFamily = {...arrFamily[index]};
        objFamily.status = "0";
        objFamily.name = "-";
        objFamily.surname = "-";
        objFamily.phone_number = "-";
        objFamily.relationship = "-";
        arrFamily[index] = objFamily;
        validation.handleChange("family." + index + ".status")("0");
        validation.handleChange("family." + index + ".name")("-");
        validation.handleChange("family." + index + ".surname")("-");
        validation.handleChange("family." + index + ".phone_number")("-");
        validation.handleChange("family." + index + ".relationship")("-");
        setUpdateDataOnEvent(null, null, arrFamily);
    };

    const setUpdateDataOnEvent = (dProfile, dEducation, dFamily) => {
        if(dProfile === null){
            dProfile = {...validation.values.profile};
        }
        if(dEducation === null){
            dEducation = [...validation.values.education];
        }
        if(dFamily === null){
            dFamily = [...validation.values.family];
        }
        setProfile(dProfile);
        setEducations(dEducation);
        setFamilys(dFamily);
    };

    const LoadDataMaritalStatus = () => {
        let url = ConfigData.API_URL + "marital-status/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                    };
                });
                setDdlMaritalStatus(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataMilitaryStatus = () => {
        let url = ConfigData.API_URL + "military-status/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                    };
                });
                setDdlMilitaryStatus(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataLevelEducation = () => {
        let url = ConfigData.API_URL + "level-education/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                    };
                });
                setDdlEducationLevel(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const LoadDataInstitution = () => {
        let url = ConfigData.API_URL + "institution/ddl";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                    };
                });
                setDdlEducationInstitution(arrData);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    return (
        <React.Fragment>
            <Form className="needs-validation"
                onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                }}
            >
                {/* Profile */}
                <Row>
                    <Col xl={12}>
                        <Card>
                            <CardHeader>
                                <h6 className="card-title mb-0">Personal</h6>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="txtProfileAddress">Address</Label>
                                            <Input id="txtProfileAddress" 
                                                name="profile.address"
                                                placeholder="Address"
                                                type="text"
                                                className="from-control"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.profile.address || ""}
                                                invalid={ validation.errors.profile?.address ? true : false }
                                            />
                                            { validation.errors.profile?.address ? 
                                                ( <FormFeedback type="invalid">{validation.errors.profile?.address}</FormFeedback> ) : false 
                                            }
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="txtProfilBankAccount">Bank account</Label>
                                            <Input id="txtProfilBankAccount" 
                                                name="profile.bank_account"
                                                placeholder="Bank account"
                                                type="text"
                                                className="from-control"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.profile.bank_account || ""}
                                                invalid={ validation.errors.profile?.bank_account ? true : false }
                                            />
                                            { validation.errors.profile?.bank_account ? 
                                                ( <FormFeedback type="invalid">{validation.errors.profile?.bank_account}</FormFeedback> ) : false 
                                            }
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="txtProfilePersonalEmail">Personal email</Label>
                                            <Input id="txtProfilePersonalEmail" 
                                                name="profile.personal_email"
                                                placeholder="Personal email"
                                                type="text"
                                                className="from-control"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.profile.personal_email || ""}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="txtProfileWorkPermitID">Work permit ID</Label>
                                            <Input id="txtProfileWorkPermitID" 
                                                name="profile.work_premit_id"
                                                placeholder="Work permit ID"
                                                type="text"
                                                className="from-control"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.profile.work_premit_id || ""}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="txtProfileTaxID">Tax ID</Label>
                                            <Input id="txtProfileTaxID" 
                                                name="profile.tax_id"
                                                placeholder="Tax ID"
                                                type="text"
                                                className="from-control"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.profile.tax_id || ""}
                                                invalid={ validation.errors.profile?.tax_id ? true : false }
                                            />
                                            { validation.errors.profile?.tax_id ? 
                                                ( <FormFeedback type="invalid">{validation.errors.profile?.tax_id}</FormFeedback> ) : false 
                                            }
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="txtProfileSsoID">SSO ID</Label>
                                            <Input id="txtProfileSsoID" 
                                                name="profile.sso_id"
                                                placeholder="Address"
                                                type="text"
                                                className="from-control"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.profile.sso_id || ""}
                                                invalid={ validation.errors.profile?.sso_id ? true : false }
                                            />
                                            { validation.errors.profile?.sso_id ? 
                                                ( <FormFeedback type="invalid">{validation.errors.profile?.sso_id}</FormFeedback> ) : false 
                                            }
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="txtProfilePassportID">Passport ID</Label>
                                            <Input id="txtProfilePassportID" 
                                                name="profile.passport_id"
                                                placeholder="Address"
                                                type="text"
                                                className="from-control"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.profile.passport_id || ""}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="ddlProfileMaritalStatus">Marital status</Label>
                                            <Select id="ddlProfileMaritalStatus"
                                                name="profile.marital_status"
                                                value={selectProfileMaritalStatus}
                                                onChange={(selected) => {
                                                    setSelectProfileMaritalStatus(selected);
                                                    validation.handleChange('profile.marital_status')((selected !== null) ? selected.value : "");
                                                }}
                                                options={ddlMaritalStatus}
                                                isClearable={true}
                                                isSearchable={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="ddlProfileMilitaryStatus">Military status</Label>
                                            <Select id="ddlProfileMilitaryStatus"
                                                name="profile.military_status"
                                                value={selectProfileMilitaryStatus}
                                                onChange={(selected) => {
                                                    setSelectProfileMilitaryStatus(selected);
                                                    validation.handleChange('profile.military_status')((selected !== null) ? selected.value : "");
                                                }}
                                                options={ddlMilitaryStatus}
                                                isClearable={true}
                                                isSearchable={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                {/* Education */}
                <Row>
                    <Col xl={12}>
                        <Card>
                            <CardHeader>
                                <h6 className="card-title mb-0">Education</h6>
                            </CardHeader>
                            <CardBody>
                                {educations.map((valE, keyE) => {
                                    if(valE.status === "1"){
                                        const educationErrors = validation.errors.education?.length && validation.errors.education[keyE] || {};
                                        indexEducation += 1;
                                        return(
                                            <div key={"divEducation" + keyE}>
                                                <Row className={"pt-2 " + ((indexEducation > 1) ? "border-top" : "")}>
                                                    <Col md={12}>
                                                        <h6 className="d-inline">{indexEducation}.</h6>
                                                        <Button type="button" color="danger" className="btn-icon float-end" 
                                                            onClick={() => { 
                                                                onClickDeleteEducation(keyE); 
                                                            }}
                                                        >
                                                            <i className="ri-delete-bin-5-line" />
                                                        </Button>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={6}>
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor={"ddlEducationLevel" + keyE}>Education level</Label>
                                                            <Select id={"ddlEducationLevel" + keyE}
                                                                name={"education." + keyE + ".id_level_education"}
                                                                value={selectEducationLevels[keyE]}
                                                                onChange={(selected) => {
                                                                    let arrSelect = selectEducationLevels;
                                                                    arrSelect[keyE] = selected;
                                                                    setSelectEducationLevels(arrSelect);
                                                                    validation.handleChange("education." + keyE + ".id_level_education")((selected !== null) ? selected.value : "");
                                                                }}
                                                                options={ddlEducationLevel}
                                                                isClearable={true}
                                                                isSearchable={true}
                                                                invalid={ educationErrors.id_level_education ? true : false }
                                                            />
                                                            { educationErrors.id_level_education ? 
                                                                ( <FormFeedback type="invalid" style={{display: "block"}}>{educationErrors.id_level_education}</FormFeedback> ) : false 
                                                            }
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={6}>
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor={"ddlEducationIntitution" + keyE}>Institution</Label>
                                                            <Select id={"ddlEducationIntitution" + keyE}
                                                                name={"education." + keyE + ".id_institution"}
                                                                value={selectEducationInstitutions[keyE]}
                                                                onChange={(selected) => {
                                                                    let arrSelect = selectEducationInstitutions;
                                                                    arrSelect[keyE] = selected;
                                                                    setSelectEducationInstitutions(arrSelect);
                                                                    validation.handleChange("education." + keyE + ".id_institution")((selected !== null) ? selected.value : "");
                                                                }}
                                                                options={ddlEducationInstitution}
                                                                isClearable={true}
                                                                isSearchable={true}
                                                                invalid={ educationErrors.id_institution ? true : false }
                                                            />
                                                            { educationErrors.id_institution ? 
                                                                ( <FormFeedback type="invalid" style={{display: "block"}}>{educationErrors.id_institution}</FormFeedback> ) : false 
                                                            }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={6}>
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor={"txtEducationFaculty" + keyE}>Faculty</Label>
                                                            <Input id={"txtEducationFaculty" + keyE}
                                                                name={"education." + keyE + ".faculty"}
                                                                placeholder="Faculty"
                                                                type="text"
                                                                className="from-control"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.education[keyE]?.faculty || ""}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={6}>
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor={"txtEducationMajor" + keyE}>Major</Label>
                                                            <Input id={"txtEducationMajor" + keyE} 
                                                                name={"education." + keyE + ".major"}
                                                                placeholder="Major"
                                                                type="text"
                                                                className="from-control"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.education[keyE]?.major || ""}
                                                            />
                                                        </FormGroup>
                                                    </Col>            
                                                </Row>
                                                <Row>
                                                    <Col md={6}>
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor={"txtEducationGraduateYear" + keyE} >Year of completion</Label>
                                                            <Input id={"txtEducationGraduateYear" + keyE} 
                                                                name={"education." + keyE + ".graduate_year"}
                                                                placeholder="Year of completion"
                                                                type="text"
                                                                className="from-control"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.education[keyE]?.graduate_year || ""}
                                                                invalid={ educationErrors.graduate_year ? true : false }
                                                            />
                                                            { educationErrors.graduate_year ? 
                                                                ( <FormFeedback type="invalid">{educationErrors.graduate_year}</FormFeedback> ) : false 
                                                            }
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={6}>
                                                    <FormGroup className="mb-3">
                                                            <Label htmlFor={"txtEducationGAP" + keyE} >GPA</Label>
                                                            <Input id={"txtEducationGAP" + keyE} 
                                                                name={"education." + keyE + ".gpa"}
                                                                placeholder="GPA"
                                                                type="text"
                                                                className="from-control"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.education[keyE]?.gpa || ""}
                                                                invalid={ educationErrors.gpa ? true : false }
                                                            />
                                                            { educationErrors.gpa ? 
                                                                ( <FormFeedback type="invalid">{educationErrors.gpa}</FormFeedback> ) : false 
                                                            }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </div>
                                        );
                                    }
                                })}
                                <div className="justify-content-center d-flex">
                                    <Button color="primary" type="button" className="btn-rounded btn-icon"
                                        onClick={onClickAddEducation}
                                    >
                                        <i className="ri-add-line" />
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                {/* Family */}
                <Row>
                    <Col xl={12}>
                        <Card>
                            <CardHeader>
                                <h6 className="card-title mb-0">Family information</h6>
                            </CardHeader>
                            <CardBody>
                                {familys.map((valF, keyF) => {
                                    if(valF.status === "1"){
                                        const familyErrors = validation.errors.family?.length && validation.errors.family[keyF] || {};
                                        indexFamily += 1;
                                        return(
                                            <div key={"divFamily" + keyF}>
                                                <Row className={"pt-2 " + ((indexFamily > 1) ? "border-top" : "")}>
                                                    <Col md={12}>
                                                        <h6 className="d-inline">{indexFamily}.</h6>
                                                        <Button type="button" color="danger" className="btn-icon float-end" 
                                                            onClick={() => { 
                                                                onClickDeleteFamily(keyF); 
                                                            }}
                                                        >
                                                            <i className="ri-delete-bin-5-line" />
                                                        </Button>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={6}>
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor={"txtFamilyName" + keyF} >First name</Label>
                                                            <Input id={"txtFamilyName" + keyF} 
                                                                name={"family." + keyF + ".name"}
                                                                placeholder="First name"
                                                                type="text"
                                                                className="from-control"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.family[keyF]?.name || ""}
                                                                invalid={ familyErrors.name ? true : false }
                                                            />
                                                            { familyErrors.name ? 
                                                                ( <FormFeedback type="invalid">{familyErrors.name}</FormFeedback> ) : false 
                                                            }
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={6}>
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor={"txtFamilySurName" + keyF} >Last name</Label>
                                                            <Input id={"txtFamilySurName" + keyF} 
                                                                name={"family." + keyF + ".surname"}
                                                                placeholder="Last name"
                                                                type="text"
                                                                className="from-control"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.family[keyF]?.surname || ""}
                                                                invalid={ familyErrors.surname ? true : false }
                                                            />
                                                            { familyErrors.surname ? 
                                                                ( <FormFeedback type="invalid">{familyErrors.surname}</FormFeedback> ) : false 
                                                            }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={12}>
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor={"txtFamilyAddress" + keyF} >Address</Label>
                                                            <Input id={"txtFamilyAddress" + keyF} 
                                                                name={"family." + keyF + ".address"}
                                                                placeholder="Address"
                                                                type="text"
                                                                className="from-control"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.family[keyF]?.address || ""}
                                                            />
                                                        </FormGroup>
                                                    </Col>            
                                                </Row>
                                                <Row>
                                                    <Col md={6}>
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor={"txtFamilyAge" + keyF} >Age</Label>
                                                            <Input id={"txtFamilyAge" + keyF} 
                                                                name={"family." + keyF + ".age"}
                                                                placeholder="Age"
                                                                type="text"
                                                                className="from-control"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.family[keyF]?.age || ""}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={6}>
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor={"txtFamilyPhone" + keyF} >Phone</Label>
                                                            <Input id={"txtFamilyPhone" + keyF} 
                                                                name={"family." + keyF + ".phone_number"}
                                                                placeholder="Phone"
                                                                type="text"
                                                                className="from-control"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.family[keyF]?.phone_number || ""}
                                                                invalid={ familyErrors.phone_number ? true : false }
                                                            />
                                                            { familyErrors.phone_number ? 
                                                                ( <FormFeedback type="invalid">{familyErrors.phone_number}</FormFeedback> ) : false 
                                                            }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={12}>
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor={"txtFamilyRelationship" + keyF}>Relationship</Label>
                                                            <Input id={"txtFamilyRelationship" + keyF} 
                                                                name={"family." + keyF + ".relationship"}
                                                                placeholder="Relationship"
                                                                type="text"
                                                                className="from-control"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.family[keyF]?.relationship || ""}
                                                                invalid={ familyErrors.relationship ? true : false }
                                                            />
                                                            { familyErrors.relationship ? 
                                                                ( <FormFeedback type="invalid">{familyErrors.relationship}</FormFeedback> ) : false 
                                                            }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </div>
                                        );
                                    }
                                })}
                                <div className="justify-content-center d-flex">
                                    <Button color="primary" type="button" className="btn-rounded btn-icon"
                                        onClick={onClickAddFamily}
                                    >
                                        <i className="ri-add-line" />
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                {/* Emergency Contact */}
                <Row>
                    <Col xl={12}>
                        <Card>
                            <CardHeader>
                                <h6 className="card-title mb-0">Emergency contact</h6>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col md={12}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="txtProfileContactName">Name</Label>
                                            <Input id="txtProfileContactName" 
                                                name="profile.contact_name"
                                                placeholder="Name"
                                                type="text"
                                                className="from-control"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.profile.contact_name || ""}
                                                invalid={ validation.errors.profile?.contact_name ? true : false }
                                            />
                                            { validation.errors.profile?.contact_name ? 
                                                ( <FormFeedback type="invalid">{validation.errors.profile?.contact_name}</FormFeedback> ) : false 
                                            }
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="txtProfilContactPhone">Phone</Label>
                                            <Input id="txtProfilContactPhone" 
                                                name="profile.contact_phone_number"
                                                placeholder="Phone"
                                                type="text"
                                                className="from-control"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.profile.contact_phone_number || ""}
                                                invalid={ validation.errors.profile?.contact_phone_number ? true : false }
                                            />
                                            { validation.errors.profile?.contact_phone_number ? 
                                                ( <FormFeedback type="invalid">{validation.errors.profile?.contact_phone_number}</FormFeedback> ) : false 
                                            }
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label htmlFor="txtProfileContactRelationship">Relationship</Label>
                                            <Input id="txtProfileContactRelationship" 
                                                name="profile.contact_relation"
                                                placeholder="Relationship"
                                                type="text"
                                                className="from-control"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.profile.contact_relation || ""}
                                                invalid={ validation.errors.profile?.contact_relation ? true : false }
                                            />
                                            { validation.errors.profile?.contact_relation ? 
                                                ( <FormFeedback type="invalid">{validation.errors.profile?.contact_relation}</FormFeedback> ) : false 
                                            }
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <div className="footer-div">
                    <div className="justify-content-center d-flex">
                        <Button color="primary" type="button" onClick={onCancel} >
                            Close
                        </Button>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Button color="success" type="submit">
                            Save
                        </Button>
                    </div>
                </div>
            </Form>
        </React.Fragment>
    );
};

export default EmployeePersonal;